/* eslint-disable import/prefer-default-export */

/**
 * Copia um objeto sem manter a reatividade.
 * Útil para permitir transformação de um objeto de um componente.
 *
 * @param {object} obj
 *
 * @returns {object} objeto clonado
 */
export const clone = obj => {
  const cloned = {};

  Object.entries(obj).forEach(pair => {
    const [key, value] = pair;

    if (typeof value === 'object' && !!value) {
      cloned[key] = clone(value);
    } else {
      cloned[key] = value;
    }
  });

  return cloned;
};
